import React from 'react';
import { Link } from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';
import './styles.css';
import {
    COLOR_NORMAL
   ,COLOR_MAIN
   ,COLOR_ACTIVE
} from "../../constants";
import {
    APP_URL
} from '../../redux/constants';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

/*import IconButton from '@material-ui/core/IconButton';
import MenuRounded from '@material-ui/icons/MenuRounded';
import Tooltip from '@material-ui/core/Tooltip';*/


const classes = {
    menu: {
        top: '7px',
        fontSize: "17px"
    },
    menuItemLink: {
        fontSize: "17px",
        textDecoration: 'none',
        color: COLOR_NORMAL
    },
    list: {
        display: 'flex',
        margin: 0,
        paddingLeft: 0,
        listStyle: 'none'
    },
    listItemLink: {
        position: 'relative',
        display: 'block',
        padding: '12px',
        outline: 'none',
        cursor: 'pointer',
        textDecoration: 'none',
        color: COLOR_NORMAL
    },
    listItemLinkTop: {
        '&:after': {
            visibility: 'hidden',
            content: "''",
            position: 'absolute',
            width: '100%',
            height: '3px',
            top: 0,
            left: 0,
            backgroundColor: COLOR_MAIN,
            transform: 'scaleX(0)'
        }
    },
    listItemLinkEnabled: {
        '&:hover': {
            color: COLOR_ACTIVE,
            '&:after': {
                visibility: 'visible',
                transform: 'scaleX(1)',
                transition: 'all .15s ease-out'
            }
        }
    },
    listItemLinkActive: {
        color: COLOR_ACTIVE,
        '&:after': {
            visibility: 'visible',
            transform: 'scaleX(1)'
        }
    },
}


const navBarList = [
    {
        code: 'DOC',
        enabled: "Y",
        linkTo: APP_URL + "/",
        tooltip: "Alt+1"
    }
   ,{
        code: 'UPLOADS',
        enabled: "Y",
        linkTo: APP_URL + "/uploads/",
        tooltip: "Alt+2"
    }
   ,{
        code: 'ADMIN',
        enabled: "Y",
        linkTo: APP_URL + "/admin/",
        tooltip: "Alt+3"
    }
   ,{
        code: 'ROLE',
        enabled: "Y",
        linkTo: APP_URL + "/role/",
        tooltip: "Alt+4"
    }
   ,{
        code: 'HISTORY',
        enabled: "Y",
        linkTo: APP_URL + "/history/",
        tooltip: "Alt+5"
    }
];

const captions = {
    "ru": {
        DOC: "Документ"
       ,UPLOADS: "Масс-загрузки"
       ,ADMIN: "Админка"
       ,ROLE: "Доступ"
       ,HISTORY: "История"
       ,menu: "Меню"
    }
   ,"en": {
        DOC: "Document"
       ,UPLOADS: "Mass upload"
       ,ADMIN: "Admin"
       ,ROLE: "Role"
       ,HISTORY: "History"
       ,menu: "Menu"
    }
};


const NavBar = ( props ) => {
    
    const caption = captions[ props.lang ] ? captions[ props.lang ] : captions[ "ru" ];

    let list = navBarList;
    if( props.user.login === null || props.user.isExternal ) return '';
    if( !( props.user.maxAccessType === 'ADMIN' || ( props.user.roles && props.user.isSuper ) ) )
        list = navBarList.filter( function(obj) { return obj.code === 'DOC' || obj.code === 'UPLOADS' } );
     
    const activeLink = props.navBar.active;
    const activeItem = list.find( item => item.linkTo === activeLink || item.linkTo === activeLink + '/' );
    const activeCode = activeItem ? activeItem.code : "";
    
    /* можно сделать кнопку для вызова меню
    const buttonMenu =
        <Tooltip title={ caption.menu } arrow>
            <IconButton
                color="primary"
                style={{ position: "relative", top: -5, left: -5 }}
                onClick={ props.onMenuOpen }
            >
                <MenuRounded fontSize="large" className="xxAdd" />
            </IconButton>
        </Tooltip>;*/
        
    return (
        <>
        <div className = "menu-popup" >
        { /*buttonMenu*/ }
        <Select
            open = { props.navBar.navMenuOpen }
            onClose = {props.onMenuClose}
            onOpen = {props.onMenuOpen}
            value = { activeCode }
            onChange = { f=>f }
            disableUnderline
            className = { props.classes.menu }
        >
        {
            list.map( (item, i) => {
                return item.linkTo && item.enabled === "Y" ?
                    <MenuItem
                        value={ item.code }
                        key={i}
                    >
                    <Link
                        className = { props.classes.menuItemLink }
                        to = { item.linkTo + props.docId }
                    >
                        { caption[ item.code ] }
                    </Link>
                    </MenuItem>
                : "";
            })
        }
        </Select>
        </div>

      
        <nav className = "menu-line">
            <ul className = { props.classes.list } >
            {
                list.map((item, i) => {
                    return (
                        <li key={i} >
                        {
                            item.linkTo && item.enabled === "Y" ? (

                                <Link
                                    className={
                                        classNames(
                                            props.classes.listItemLink,
                                            props.classes.listItemLinkTop,
                                            ( item.linkTo === props.navBar.active ||
                                              item.linkTo === props.navBar.active + '/'
                                            ) ? props.classes.listItemLinkActive : props.classes.listItemLinkEnabled
                                        )
                                    }
                                    to={ item.linkTo + props.docId
                                    /* не нужно, onNavItemClick вызывается в NavBar.js
                                    onClick={ () => props.onNavItemClick( item.linkTo ) }*/ }
                                >{ caption[ item.code ] }
                                
                                {/*<div style={{ fontSize: 12, textAlign: "center", color: "#909090" }} >
                                { item.tooltip }
                                </div> TODO вывести hotkey по hover на меню*/}
                                </Link>

                            ) : ("")
                        }
                        </li>
                    );
                })
            }
            </ul>
        </nav>
        </>
    );
};

export default withStyles(classes)(NavBar);
